import React, { useState } from "react";
import { toast } from "sonner";
import { FileWarning } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { ujmsCitationBenchWarrant } from "../services/ujmsApi";
import { Field, inputCls, btnGhost, cls } from "./ui";

export const ftaCitationId = (task) => (String(task?.ref_id || "").startsWith("fta:") ? task.ref_id.slice(4) : null);

export function BenchWarrantButton({ citationId, label = "Issue Bench Warrant", testId, onDone, className }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" data-testid={testId}
        className={cls("inline-flex items-center gap-1.5 bg-red-700 hover:bg-red-800 text-white text-xs font-bold px-2.5 py-1 rounded-sm transition-colors", className)}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}>
        <FileWarning className="w-3.5 h-3.5" /> {label}
      </button>
      {open && <BenchWarrantDialog citationId={citationId} onClose={() => setOpen(false)} onDone={onDone} />}
    </>
  );
}

function BenchWarrantDialog({ citationId, onClose, onDone }) {
  const [bond, setBond] = useState("");
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const r = await ujmsCitationBenchWarrant(citationId, { bond_amount: bond === "" ? null : Number(bond), notes });
      toast.success(`Bench warrant ISSUED on ${r.data.case_number} — FTA task closed${bond ? ` · bond $${Number(bond).toLocaleString()}` : ""}`);
      onClose();
      onDone?.(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to issue bench warrant"); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="fta-bench-warrant-dialog" onClick={(e) => e.stopPropagation()}>
        <DialogHeader><DialogTitle className="flex items-center gap-2"><FileWarning className="w-4 h-4 text-red-700" /> Issue bench warrant — failure to appear</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">
          Issues a BENCH warrant on the citation's case immediately, dockets it, schedules the warrant return and closes the FTA review task.
        </p>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Bond amount (optional)">
            <input type="number" min="0" step="50" className={inputCls} value={bond} onChange={(e) => setBond(e.target.value)} placeholder="e.g. 1000" data-testid="fta-bw-bond" />
          </Field>
          <Field label="Notes (optional)">
            <input className={inputCls} value={notes} onChange={(e) => setNotes(e.target.value)} data-testid="fta-bw-notes" />
          </Field>
        </div>
        <DialogFooter>
          <button className={btnGhost} onClick={onClose} data-testid="fta-bw-cancel">Cancel</button>
          <button className="inline-flex items-center gap-1.5 bg-red-700 hover:bg-red-800 text-white text-sm font-semibold px-3.5 py-1.5 rounded-sm disabled:opacity-50"
            disabled={busy} onClick={submit} data-testid="fta-bw-confirm">{busy ? "Issuing…" : "Issue Bench Warrant"}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
